import Vue from "vue";
import Router from "vue-router";
import Home from "../src/pages/Home/Page-Home.vue";
import App from "../src/components/Dashboard/mobileDashboard.vue";
import Purchase from "../src/pages/Purchase/Page-Purchase.vue"
import PurchaseMobile from "../src/components/Purchase/PurchaseMobile.vue"
import Boleto from "../src/components/Boleto/Index.vue"
import GeneralInventory from "../src/pages/Inventory/Page-Inventory.vue"
import GeneralPrescription from "../src/pages/Prescription/Page-Prescription.vue"
import MobileGeneral from "../src/components/Prescription/MobileGeneral.vue"
import Login from "../src/pages/Login/Page-Login.vue"
import Settings from "./pages/Settings/Page-Settings.vue"
import SettingsMobile from "./pages/Settings/Page-SettingsMobile.vue"
import SaleCompleteScreen from "../src/pages/SaleCompleteScreen/Page-SaleCompleteScreen.vue";
import Compendio from "../src/pages/Compendio/Page-Compendio.vue";
import AppCompendio from "../src/pages/AppCompendio/Page-Compendio.vue";
import SaleSimpleScreen from "../src/pages/SaleSimpleScreen/Page-SaleSimpleScreen.vue";
import SaleSimpleScreenMobile from "../src/components/GeneralSalesScreen/simpleSalesScreenMobile.vue";
import GeneralPDV from "../src/pages/GeneralPDV/Page-GeneralPDV.vue";
import GenInspect from "../src/pages/GenInspect/GenInspectPage.vue";
import Reports from "../src/pages/ReportsGeneral/Page-Reports.vue";
import Stock from "../src/pages/Stock/Page-Stock.vue";
import GeneralInventoryMobile from "./components/InventoryControl/GeneralInventoryMobile.vue";
import FinancialMovements from "../src/pages/FinancialMovements/Page-FinancialMovements.vue";
import Registers from "../src/pages/Registers/Page-Registers.vue";
import Mobile from "./components/Registers/Mobile.vue";
import FiscalIssuance from "../src/pages/FiscalIssuance/Page-FiscalIssuance.vue";
import Consultation from "../src/pages/Consultation/Page-Consultation.vue"
import SimpleCashier from "../src/components/Cashier/SimpleCashier.vue";
import Budget from "./pages/Budget/Page-Budget.vue"
import Crm from "./pages/Crm/Crm.vue"
import Marketing from './pages/Marketing/marketing.vue'
import Checks from './pages/Checks/Page-Checks.vue'
import store from "./store"


Vue.use(Router);

const routes = [
  {
    path: "/",
    component: Login,
  },
  {
    path: "/home",
    component: Home,
    name: "home",
    meta: {
      auth: true,
    },
  },
  {
    path: "/mobile",
    component: App,
    name: "mobile",
    meta: {
      auth: true,
    },
  },
  {
    path: "/cadastros",
    component: Registers,
    name: "cadastros",
    meta: {
      auth: true
    }
  },
  {
    path: "/mobile-cadastros",
    component: Mobile,
    name: "mobile-cadastros",
    meta: {
      auth: true
    }
  },
  {
    path: "/fiscal",
    component: FiscalIssuance,
    name: "fiscal",
    meta: {
      auth: true
    }
  },
  {
    path: "/vendas",
    component: SaleCompleteScreen,
    name: "vendas",
    meta: {
      auth: true
    }
  },
  {
    path: "/vendas-simples",
    component: SaleSimpleScreen,
    name: "vendas-simples",
    meta: {
      auth: true
    }
  },
  {
    path: "/vendas-simples-mobile",
    component: SaleSimpleScreenMobile,
    name: "vendas-simples-mobile",
    meta: {
      auth: true
    }
  },
  {
    path: "/pdv",
    component: GeneralPDV,
    name: "pdv",
    meta: {
      auth: true
    }
  },
  {
    path: "/financeiro",
    component: FinancialMovements,
    name: "financeiro",
    meta: {
      auth: true
    }
  },
  {
    path: "/financeiro/:id",
    component: FinancialMovements,
    meta: {
      auth: true
    }
  },
  {
    path: "/caixa",
    component: SimpleCashier,
    name: "caixa",
    meta: {
      auth: true
    }
  },
  {
    path: "/compras",
    component: Purchase,
    name: "compras",
    meta: {
      auth: true
    }
  },
  {
    path: "/compras-mobile",
    component: PurchaseMobile,
    name: "compras-mobile",
    meta: {
      auth: true
    }
  },
  {
    path: "/configuracoes",
    component: Settings,
    name: "configuracoes",
    meta: {
      auth: true
    }
  },
  {
    path: "/configuracoes-mobile",
    component: SettingsMobile,
    name: "configuracoes-mobile",
    meta: {
      auth: true
    }
  },
  {
    path: "/relatorios",
    component: Reports,
    name: "relatorios",
    meta: {
      auth: true
    }
  },
  {
    path: "/estoque",
    component: Stock,
    name: "estoque",
    meta: {
      auth: true
    }
  },
  {
    path: "/estoque-mobile",
    component: GeneralInventoryMobile,
    name: "estoque-mobile",
    meta: {
      auth: true
    }
  },
  {
    path: "/inventario",
    component: GeneralInventory,
    name: "inventario",
    meta: {
      auth: true
    }
  },
  {
    path: "/receita",
    component: GeneralPrescription,
    name: "receita",
    meta: {
      auth: true
    }
  },
  {
    path: "/receita-mobile",
    component: MobileGeneral,
    name: "receita-mobile",
    meta: {
      auth: true
    }
  },
  {
    path: "/compendio",
    component: Compendio,
    name: "compendio",
    meta: {
      auth: true
    }
  },
  {
    path: "/app/compendio",
    component: AppCompendio,
    name: "app-compendio",
    meta: {
      auth: true
    }
  },
  {
    path: "/consultas",
    component: Consultation,
    name: "consultas",
    meta: {
      auth: true
    }
  },
  {
    path: "/inspecao",
    component: GenInspect,
    name: "inspecao",
    meta: {
      auth: true
    }
  },
  {
    path: "/boleto",
    component: Boleto,
    name: "boleto",
    meta: {
      auth: true
    }
  },
  {
    path: "/cheques",
    component: Checks,
    name: "cheques",
    meta: {
      auth: true,
      requiredPlan: "gestao_completo"
    }
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "home" },
  },
  {
    path: "/caixa-simples",
    component: SimpleCashier,
    name: "caixa-simples",
    meta: {
      auth: true
    }
  },
  {
    path: "/orcamento",
    component: Budget,
    name: "orcamento",
    meta: {
      auth: true
    }
  },
  {
    path: "/crm",
    component: Crm,
    name: "crm",
    meta: {
      auth: true
    }
  },
  {
    path: "/marketing",
    component: Marketing,
    name: "marketing",
    meta: {
      auth: true
    }
  },
];

const router = new Router({
  mode: "history",
  routes,
});


router.beforeEach((to, from, next) => {
  store.commit("SET_NAV_ITEM_SELECTED", to.matched[0].name)

  if (to.matched[0].meta.auth && !localStorage.getItem("token")) {
    return next({ path: "/" });
  }

  const tipoPlano = store.state.dataPlan?.tipoPlano || localStorage.getItem("plan");
  if (to.matched[0].meta.requiredPlan && tipoPlano !== to.matched[0].meta.requiredPlan) {
    return next({ path: "/home" });
  }

  if (!hasRoutePermission(to)) return next({ path: "/home" });

  return next();
});

function hasRoutePermission(to) {
  const permissions = JSON.parse(localStorage.getItem('permissions') || null)
  const key = to.path.replace('/', '')

  if (permissions && permissions[key] && key !== "configuracoes" && key !== "agenda" && key !== "inspecao") {
    return Boolean(permissions[key].painelPrincipal);
  }

  if (key === "ordem" && permissions)
    return Boolean(permissions.ordensDeServico?.painelPrincipal);
  if ((key === "fiscal" || key === "inspecao") && permissions)
    return Boolean(permissions.emissaoFiscal?.painelPrincipal);

  return true;
}

export default router;
